import { getAPIUrl } from '../API'
import { SpiderSearchTypes } from '../apiConstants'

export type SpiderSearchTrustParams = {
  trustName: string
  trustNo?: string
  reference: string
  type: 'trust'
}

export type SpiderSearchConsumerParams = {
  idNo: string
  reference: string
  type: 'consumer'
}

export type SpiderSearchCompanyParams = {
  companyID?: string
  companyName: string
  reference: string
  type: 'company'
}
export type FullTitle = any
export type SectionalTitle = any

export type SpiderSearchResponse = {
  fullTitle: FullTitle[]
  sectionalTitle: SectionalTitle[]
  fullTitleCount: number
  sectionalTitleCount: number
}

export type SpiderSearchParams =
  | SpiderSearchTrustParams
  | SpiderSearchConsumerParams
  | SpiderSearchCompanyParams

export const spiderSearch = async (values: SpiderSearchParams) => {
  const body = {
    ...values,
    searchType: getSearchType(values.type),
  }
  const result = await fetch(`${getAPIUrl()}/Deeds/NationalDeedSearch`, {
    method: 'POST',
    body: JSON.stringify(body),
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + sessionStorage.getItem('jwt'),
    },
  })
  if (result.ok) {
    const data = await result.json()
    if (
      data.statusCode === 200 &&
      (!data.data.fullTitle || data.data.fullTitle.length === 0) &&
      (!data.data.sectionalTitle || data.data.sectionalTitle.length === 0)
    ) {
      let customMessage = 'No results found for: '
      if ('idNo' in body) {
        customMessage += `Id number: ${body.idNo}`
      }
      if ('trustName' in body) {
        customMessage += `Trust name: ${body.trustName}, `
      }
      if ('trustNo' in body) {
        customMessage += `Trust number: ${body.trustNo}`
      }
      if ('companyName' in body) {
        customMessage += `Company name: ${body.companyName}, `
      }
      if ('companyID' in body) {
        customMessage += `Registration Number: ${body.companyID}`
      }

      alert(customMessage)
    }
    return data.data
  }
}

const getSearchType = (type: 'trust' | 'consumer' | 'company') => {
  if (type === 'trust') {
    return SpiderSearchTypes.TRUST
  }
  if (type === 'consumer') {
    return SpiderSearchTypes.PERSON
  }
  if (type === 'company') {
    return SpiderSearchTypes.COMPANY
  }
  return 0
}

export type PropertyCount = {
  owner: string
  ownerIDNo: string
  count: number
}

export type PropertyCounts = {
  fullTitlePropertyCount: PropertyCount[]
  sectionalTitlePropertyCount: PropertyCount[]
}

export type SearchPropertyCountsParams = {
  name: string
  type: 'company' | 'trust'
}

export const spiderPropertyCounts = async (
  params: SearchPropertyCountsParams,
) => {
  const { name, type } = params

  const body = {
    name,
    type: getSearchType(type),
  }

  const res = await fetch(`${getAPIUrl()}/Deeds/PropertCountByName`, {
    method: 'POST',
    body: JSON.stringify(body),
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + sessionStorage.getItem('jwt'),
    },
  })
  const response = await res.json()
  if (
    response.statusCode === 200 &&
    (!response.data.fullTitlePropertyCount ||
      response.data.fullTitlePropertyCount.length === 0) &&
    (!response.data.sectionalTitlePropertyCount ||
      response.data.sectionalTitlePropertyCount.length === 0)
  ) {
    let customMessage = 'No results found for: '
    if ('idNo' in body) {
      customMessage += `Id number: ${body.idNo}`
    }
    if ('trustName' in body) {
      customMessage += `Trust name: ${body.trustName}, `
    }
    if ('trustNo' in body) {
      customMessage += `Trust number: ${body.trustNo}`
    }
    if ('name' in body) {
      customMessage += `Company name: ${body.name}, `
    }
    if ('companyID' in body) {
      customMessage += `Registration Number: ${body.companyID}`
    }

    alert(customMessage)
  }
  return response.data
}
